import { useCallback, useMemo } from 'react';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';

import { UsersQueryApi } from '@lib/api/endpoints';
import { RootState } from '@lib/redux.lib/store';

export const useUserVehicles = () => {
  const userId = useSelector((state: RootState) => state.app.user.profile?.id);

  const getVehicles = useCallback(
    () => UsersQueryApi.getUserVehicles(userId),
    [userId]
  );

  const {
    data = [],
    isLoading: isVehicleDataLoading,
    error,
  } = useQuery({
    queryKey: ['userVehicles', userId],
    queryFn: getVehicles,
    enabled: !!userId,
    refetchOnWindowFocus: false,
  });

  const isLoading = useMemo(
    () => !userId || isVehicleDataLoading,
    [userId, isVehicleDataLoading]
  );

  return { data, isLoading, error };
};
